module.exports = __webpack_public_path__ + "img/file-chart-pie.29d76306.svg";